import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { usePublish } from '@atlaskit/rovo-triggers';
import AiGenerativeTextIcon from '@atlaskit/icon-lab/core/ai-generative-text';

import { useSmartCreationModalActions } from '@confluence/smart-creation-modal-store/entry-points/smartCreationModalStore';

// eslint-disable-next-line import/no-cycle
import { CustomAction } from './SharedActionMenuItems';

const i18n = defineMessages({
	whiteboardToLiveDocWithAi: {
		id: 'content-types-header.content-types.more-actions.whiteboard-create-with-ai',
		defaultMessage: 'Create Live Doc with Rovo',
		description:
			'The label for the more actions button that triggers whiteboard to page conversion',
	},
});

export const WHITEBOARD_TO_LIVE_DOC_PROMPT = 'Create a Live Doc from this whiteboard.';

export type WhiteboardToLiveDocMenuItemProps = {
	spaceKey: string;
};

export const WhiteboardToLiveDocMenuItem = ({ spaceKey }: WhiteboardToLiveDocMenuItemProps) => {
	const { openModal } = useSmartCreationModalActions();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const intl = useIntl();
	const publish = usePublish('ai-mate');

	const title = intl.formatMessage(i18n.whiteboardToLiveDocWithAi);

	const handleWhiteboardToLiveDocWithAi = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'whiteboardToLiveDocWithAi',
				source: 'overflowMenu',
			},
		}).fire();

		openModal('whiteboardToLiveDocAiConversion', spaceKey, undefined, true);

		publish({
			type: 'chat-new',
			source: 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON',
			openChat: false,
			data: {
				name: title,
				dialogues: [],
				prompt: WHITEBOARD_TO_LIVE_DOC_PROMPT, // Hardcoded to en-us for now until we can ensure backend support for other locales
				contentContext: 'global',
			},
		});
	}, [createAnalyticsEvent, openModal, spaceKey, publish, title]);

	const item = {
		id: 'whiteboard-to-live-doc-with-ai',
		text: title,
		onClick: handleWhiteboardToLiveDocWithAi,
	};

	return <CustomAction item={item} key={item.id} icon={<AiGenerativeTextIcon label="" />} />;
};
